<template>
  <form class="modal__form" @submit.prevent="">
    <header class="modal__header">
      <h2>Password recovery</h2>

      <div class="img" @click="$emit('close')">
        <img :src="mediaBaseUrl + 'close.svg'" alt="close">
      </div>
    </header>

    <div class="fields">
      <label v-for="field in formFields" :key="field.name" :class="[{field_error: field.error}]">
        <span>{{field.name}}</span>
        <input v-model="field.value" :type="field.type" required>
        <span v-show="field.error" class="error">{{field.errorMessage}}</span>
      </label>
    </div>

    <custom-button @click="submitForm">
      Submit
    </custom-button>
  </form>
</template>

<script>
export default {
  name: "Register",
  inject: ["mediaBaseUrl"],

  data() {
    return {
      showPassword: false,
      formFields: [
        {
          name: "E-mail",
          type: "email",
          value: "",
          error: false,
          errorMessage: "E-mail address entered incorrectly",
          validate() {
            return this.value.length > 0;
          },
        },
      ],
    };
  },

  computed: {
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
  },

  methods: {
    submitForm() {
      let errors = false;
      for (const field of this.formFields) {
        field.error = !field.validate();
        errors = errors || field.error;
      }

      if (!errors) {
        this.$emit('action', {
          'email': this.formFields[0].value,
        });
      }
    },
  },
}
</script>
